import { Entity } from '@/store/shared/entity'



export default class ProductName extends Entity<number>{
    name:string;
    nameEn:string;
    unit:string;
    code:string;
}